export default {
    key: 'kleine-scheidegg',
    common: {
        productName: 'core.productNames.kleine-scheidegg',
        splashMessage: 'offerFlow.splashMessage.kleine-scheidegg',
        headingAside: 'offerFlow.headingAside.kleine-scheidegg',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.kleine-scheidegg',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
